// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'

import App from './App'
import router from './router'
import store from '@/store'
import VueCookie from 'vue-cookie'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/scss/common.scss'
import '@/css/iconfont.css'
import "@/assets/scss/global.scss"
import httpRequest from '@/utils/httpRequest'
import _ from 'lodash'
import utils from '@/utils/utils'
import {getSelectDesc, findMenuOfUrl} from '@/utils'
import VueI18n from 'vue-i18n'
import {zh} from '@/assets/langs/zh.js'
import {en} from '@/assets/langs/en.js'

Vue.use(ElementUI)
Vue.use(VueCookie)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh', // 默认语言
  fallbackLocale: 'zh',
  messages: {
    en,
    zh
  }, // 语言包
})

Vue.config.productionTip = false

Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$findMenuOfUrl = findMenuOfUrl
Vue.prototype.getSelectDesc = getSelectDesc     // 获取枚举描述

// 注册过滤器
Object.keys(utils.filters).forEach(key => {
  Vue.filter(key, utils.filters[key])
})

window.SITE_CONFIG = {
  contextPath: '/api',
  // basContextPath: '/api/bas'
  basContextPath: '/api/bas/front'
}
// 保存整站vuex本地储存初始状态
window.SITE_CONFIG['storeState'] = _.cloneDeep(store.state)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js